export default {"src":"/_next/static/media/ts-logo.02d0f52e.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};